// Re-export RoadieService from the common package.
// Stage is resolved here using the deploy-time dev replacement.
// The engagementId is passed as the X-Api-Key header for per-client throttling in RoadieMulberry.
import { RoadieService as CommonRoadieService } from '@amzn/d2c-application-website-common';
import { getAsinStage } from 'src/utils/roadieHelper';
import { getEngagementId } from 'src/services/engagementId';

export type { STAGE, STAGE_MAP } from '@amzn/d2c-application-website-common';

export class RoadieService extends CommonRoadieService {
  constructor(csrfToken?: string) {
    super(getAsinStage(), csrfToken, undefined, getEngagementId());
  }
}
